/** Common zones a timezone picker floats to the top of its list — quick picks
 *  shown first (with the viewer's own zone) ahead of the full IANA set, and the
 *  fallback list on engines without `Intl.supportedValuesOf`. Shared by every
 *  schedule editor so the quick picks never drift between features. */
export const SCHEDULE_TIME_ZONES = [
  'UTC',
  'America/Los_Angeles',
  'America/Chicago',
  'America/New_York',
  'Europe/London',
  'Europe/Berlin',
  'Europe/Paris',
  'Asia/Kolkata',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Australia/Sydney',
] as const;
